export enum SearchPageResultType {
  SEARCH_PAGE_RESULT_TYPE_UNKNOWN = 'SEARCH_PAGE_RESULT_TYPE_UNKNOWN',
  PRODUCT_RESULTS = 'PRODUCT_RESULTS',
  BRAND_RESULTS = 'BRAND_RESULTS',
}
